import { render, staticRenderFns } from "./SearchProductFilterContent.vue?vue&type=template&id=64e50dd8&scoped=true&"
import script from "./SearchProductFilterContent.vue?vue&type=script&lang=js&"
export * from "./SearchProductFilterContent.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductFilterContent.vue?vue&type=style&index=0&id=64e50dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e50dd8",
  null
  
)

export default component.exports